var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('img',{attrs:{"src":"https://h5.chuxingyouhui.com/shop/assets/vscode-test/card.png"}})])
}]

export { render, staticRenderFns }